<template>
    <el-dialog ref="costDialog" :before-close="handleDialogClose" :close-on-click-modal="false" :title="costId ? '编辑成本' : '新建成本'" :visible.sync="costDialog" class="custom-form-dialog" width="520px">
        <el-form ref="formData" :model="formData" :rules="formRules" label-position="top" v-loading="loading">
            <el-form-item label="成本名称" prop="cost_name">
                <el-input size="small" v-model="formData.cost_name" placeholder="请输入成本名称" ></el-input>
            </el-form-item>
            <el-form-item label="成本金额" prop="price">
                <el-input-number size="small" v-model="formData.price" placeholder="请输入成本金额" :precision="2" :controls="false"></el-input-number>
            </el-form-item>
            <el-form-item label="成本详情" prop="note">
                <el-input size="small" v-model="formData.note" type="textarea" placeholder="请输入成本详情" ></el-input>

            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button :disabled="BtnDisabled" type="primary" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {ProjectManageCostAdd,ProjectManageCostEdit,ProjectManageCostDetail } from "@/api/index.js"
export default {
    name: "cost_tpl",
    components: {

    },
    props: {
        costDialog: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: Number,
            default: 0
        },
        costId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            BtnDisabled:false,
            loading:false,
            formData: {
                cost_name:"",
                price:0.00,
                note: "",
            },
            formRules: {
                cost_name: [{required: true, message: "请输入成本名称", trigger: 'blur'}],
                price: [{required: true, message: "请输入成本金额", trigger: 'blur'}],
            },

        }
    },
    created() {
        if(this.costId){
            this.getProjectManageCostDetail()
        }
    },
    methods: {
        getProjectManageCostDetail(){
            let postData = {
                id:this.costId
            }
            this.loading = true
            ProjectManageCostDetail(postData).then(res => {
                if (res.code === 200) {
                    let {cost_name,price,note} = res.data
                    this.formData.cost_name = cost_name
                    this.formData.price = price
                    this.formData.note = note

                }
                this.loading = false
            })
        },
        handleDialogClose() {
            this.$emit("update:costDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    let postData = JSON.parse(JSON.stringify(this.formData))
                    postData.price = postData.price.toFixed(2)
                    postData.project_manage_id = this.projectId
                    this.BtnDisabled = true
                    if(this.costId){
                        postData.id = this.costId
                        ProjectManageCostEdit(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit("update:costDialog", false)
                                this.$emit('success')
                            }
                            this.BtnDisabled = false
                        })
                    }else {
                        ProjectManageCostAdd(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit("update:costDialog", false)
                                this.$emit('success')
                            }
                            this.BtnDisabled = false
                        })
                    }

                }
            })
        },


    }
}
</script>
<style lang="scss" scoped>
    .el-input-number{
        width: 100%;
        ::v-deep .el-input__inner{
            text-align: left;
        }
    }
</style>
